import { Customer } from "@hydrologiq/gql-experience/graphql"
import { Flex, SimpleGrid, GridItem } from "@chakra-ui/react"

import { CustomerArchive } from "./CustomerArchive"

const CustomerAdmin = ({ customer }: { customer?: Customer | undefined }) => {
  return (
    <SimpleGrid columns={{ base: 2 }} gap={5} marginBottom={5}>
      <GridItem>
        <Flex justifyContent={"space-between"} width={"fit-content"} gap={5} flexWrap={"wrap"}>
          <CustomerArchive customer={customer ?? undefined} />
        </Flex>
      </GridItem>
    </SimpleGrid>
  )
}

export default CustomerAdmin
